<template>
  <router-link v-bind="$attrs" custom v-slot="{ href, navigate, isActive }">
    <li :class="{ active: isActive }" @click="hideSidebar">
      <a :href="href" class="nav-link" @click="navigate">
        <slot />
      </a>
    </li>
  </router-link>
</template>

<script>
export default {
  inheritAttrs: false,
  methods: {
    hideSidebar() {
      if (this.$sidebar && this.$sidebar.showSidebar === true) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>
